import { Component } from '@angular/core';
import { PartiallyDeliveredReasonsCreateComponent } from '../../../../components/admin-dashboard-component/partially-delivered-reasons-component/partially-delivered-reasons-create-component/partially-delivered-reasons-create-component';

@Component({
  selector: 'app-partially-delivered-reasons-create',
  imports: [
    PartiallyDeliveredReasonsCreateComponent
  ],
  templateUrl: './partially-delivered-reasons-create.html',
  styleUrl: './partially-delivered-reasons-create.scss'
})
export class PartiallyDeliveredReasonsCreate {

}
